<template>
  <div id="g-recaptcha" ref="refRecaptchaDiv" />
</template>

<script setup lang="ts">
import { onMounted, ref, Ref } from "vue";

const refRecaptchaDiv: Ref<HTMLElement | null> = ref(null);

function renderRecaptchaWidget(): void {
  const interval = setInterval(() => {
    const grecaptcha = (window as any).grecaptcha;
    if (typeof grecaptcha === "object" && typeof grecaptcha?.render === "function" && refRecaptchaDiv.value) {
      clearInterval(interval);
      grecaptcha.render(refRecaptchaDiv.value, {
        callback: "assignRecaptchaRegister",
        "error-callback": "assignRecaptchaRegister",
        "expired-callback": "assignRecaptchaRegister",
        sitekey: import.meta.env.VITE_RECAPTCHA_SITEKEY,
        size: "invisible",
      });
    }
  }, 60);
}

onMounted(() => {
  renderRecaptchaWidget();
});
</script>
